import { Link } from "react-router";
import type { FeedbackDetail } from "@/lib/feedback/feedback-detail";
import { FeedbackDetailView } from "@/components/feedback-detail/feedback-detail-view";
import { FeedbackActionsBar } from "@/components/feedback-detail/feedback-actions-bar";
import { FeedbackHistory, type FeedbackHistoryItem } from "@/components/feedback-detail/feedback-history";
import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { load } from "../api/load";
import { seg } from "../api/respond";

type Data = { feedback: FeedbackDetail; history: FeedbackHistoryItem[] };

export function loader({ params }: LoaderFunctionArgs) {
  return load<Data>(`/api/v1/admin/feedback/${seg(params.id!)}`);
}

export default function FeedbackDetailPage() {
  const { feedback, history } = useLoaderData() as Data;
  const now = new Date();

  return (
    <div className="flex flex-col gap-6">
      <nav className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[13px] text-fc-text-secondary">
          <Link to="/admin" className="text-fc-text-dim hover:text-fc-text">
            Home
          </Link>
          <span className="text-fc-text-dim">/</span>
          <Link
            to="/admin/feedback"
            className="text-fc-text-dim hover:text-fc-text"
          >
            Feedback
          </Link>
          <span className="text-fc-text-dim">/</span>
          <span className="font-medium text-fc-text">{feedback.userName}</span>
        </div>
        <Link
          to="/admin/feedback"
          className="inline-flex items-center gap-2 rounded-md border border-fc-border bg-fc-overlay px-3 py-1.5 text-[12.5px] text-fc-text hover:border-fc-brand"
        >
          ← Back to list
        </Link>
      </nav>

      <FeedbackActionsBar
        feedbackId={feedback.id}
        currentStatus={feedback.status}
      />

      <FeedbackDetailView feedback={feedback} now={now} />

      <FeedbackHistory feedbackId={feedback.id} initial={history} />
    </div>
  );
}
